import React, { useState, useCallback } from 'react';
import { css } from '@emotion/core';
import { useMachine } from '@xstate/react';

import cogotoast from 'cogo-toast';
import Spinner from '~/theseus/components/Spinner';
import SectionToggle from '~/theseus/components/SectionToggle';

import machine from './machine';

export default function AdPreview(props) {
  const { validation, getPreview } = props;

  const [iframe, setIframe] = useState(null);
  const [previewType, setPreviewType] = useState('DESKTOP_FEED_STANDARD');

  const [state, send] = useMachine(machine, {
    services: {
      getIframe: (_, e) => getPreview(e.data),
    },
    actions: {
      alertOfIframeError: () => cogotoast.error('There was an issue creating your ad preview', { position: 'bottom-right' }),
      alertOfLoadingError: () => cogotoast.error('The request to load your ad preview timed out', { position: 'bottom-right' }),
      setIframe: (_, e) => setIframe(e.data),
    },
  });

  const createPreview = useCallback(() => {
    if (validation === undefined || validation()) {
      send({ type: 'GENERATE_PREVIEW', data: previewType });
    }
  }, [previewType, validation]);

  const handleChange = useCallback(e => setPreviewType(e.target.value), []);

  return (
    <div className="ad-preview">
      <div className="ad-preview__controls">
        <select
          id="preview-selection"
          disabled={state.matches('loading')}
          value={previewType}
          onChange={handleChange}
        >
          <option value="DESKTOP_FEED_STANDARD"> Desktop Feed</option>
          <option value="MOBILE_FEED_STANDARD">Mobile Feed</option>
          <option value="RIGHT_COLUMN_STANDARD">Desktop Right Column</option>
          <option value="INSTAGRAM_STANDARD">Instagram Feed</option>
          <option value="INSTAGRAM_STORY">Instagram Story</option>
        </select>
        <button
          type="button"
          disabled={state.matches('loading')}
          onClick={createPreview}
        >
          Preview Ad
        </button>
      </div>
      <div className="ad-preview__container">
        <SectionToggle enabledOn={state.matches('loading')}>
          <Spinner radius={60} css={css`margin: 2em;`} data-testid="spinner" />
        </SectionToggle>
        <SectionToggle disabledOn={state.matches('loading') || iframe === null}>
          <div dangerouslySetInnerHTML={{ __html: iframe }} />
        </SectionToggle>
      </div>
    </div>
  );
}
